// const API_BASE_URL = 'http://127.0.0.1:8000/api';
const API_BASE_URL = 'https://api.blazestudioart.pl/api'

export default {
  API_BASE_URL,
};